import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, claimsHomeRoute } from 'config/Api.Config';
import { isMobile } from 'react-device-detect';
import useClaim from './Claim.Hooks';
import ClaimDelete from './sections/Claim.Delete';
import ClaimFilters from './sections/Claim.Filters';
import ClaimList from './sections/Claim.List';
import { isDesktop } from 'react-device-detect';
import ClaimActions from './sections/Claim.Actions';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { useClaimCreatePageRouter } from 'app/pages/claims/createClaim/Index';

export const claimIndexRoute = claimsHomeRoute + '/claim/:action?/:id?';
export default function ClaimIndex() {
  const { lang } = getLocales();
  const claimHook = useClaim();
  const claimCreatePageRouter = useClaimCreatePageRouter();

  if (!claimHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={claimHook}
        render={({ listApi, views, canAddClaim }) => (
          <>
            {views.delete && <ClaimDelete />}
            <Page
              class={ThemePageList}
              isLoading={listApi.isExecuting}
              header={
                <>
                  <h2 style={{ marginRight: 'auto' }} children={lang.claims} />
                  <Box class={ThemeWrapperStack}>
                    {isMobile && <ClaimFilters />}
                    <ClaimActions key="actions" />
                    <Button
                      class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                      active
                      media={<Icon class="fas-plus" />}
                      render={!isMobile && lang.addNew}
                      disabled={!canAddClaim}
                      onClick={claimCreatePageRouter.redirect}
                    />
                  </Box>
                </>
              }
              subHeader={isDesktop && <ClaimFilters />}
              render={<ClaimList key="list" />}
              footer={
                <Pagination
                  class={ThemePaginationRounded}
                  count={listApi.payload?.count}
                  offset={listApi.body?.offset}
                  limit={listApi.body?.limit}
                  onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                  onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
                />
              }
            />
          </>
        )}
      />
    </>
  );
}
